import styled, { css } from 'styled-components';
const percentageSize = 1.3;

export const DetailsFooter = styled.footer`
  background-color: transparent;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: start;

  @media screen and (max-width: 464px) {
    display: block;
  }
`;

export const FooterBtns = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 0;
  padding: 0px;
  padding-left: 20px;
  @media screen and (max-width: 464px) {
    padding-left: 0px;
  }
`;

export const FooterBtn = styled.button`
  display: ${({ display }) => (display ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0;
  padding: 0px;
  padding-right: 3px;
  background-color: transparent;
  border: 0px solid transparent;
  transform: scale(0.8);
  filter: ${({ isShow, isHover, isEnabled, hasFilters }) =>
    isEnabled ? (isShow || isHover || hasFilters ? 'none' : 'brightness(0) invert(1)') : 'none'};
  fill: ${({ isShow, isHover, isEnabled, hasFilters }) =>
    isEnabled ? (isShow || (isHover && window.innerWidth > 768) || hasFilters ? '#febf00' : 'white') : '#666666'};

  @media screen and (max-width: 464px) {
    display: ${({ isEnabled }) => (isEnabled ? 'block' : 'none')};
  }
`;

export const StylesPopUp = styled.div`
  /* padding-left: 5px; */
`;

export const SeparatorLine = styled.hr`
  margin: 0px;
  margin-top: 10px;
`;

export const PopUpCloseBtn = styled.button`
  background: #333333;
  color: white;
  opacity: 90%;
  border-radius: 50%;
  border: 0;
  box-sizing: border-box;
  text-align: right;
`;

export const PopUpTitle = styled.p`
  text-align: left;
  padding: 0px;
  margin: 0px;
  margin-top: 5px;
  padding-left: 5px;
  width: 100%;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const PopUpHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const LayerStylesInfo = styled.div`
  padding-left: 10px;
  padding-bottom: 10px;
`;

export const LayerStylesInfoHeader = styled.div`
  display: flex;
  margin: 0px;
  padding: 0px;
  align-items: flex-start;
`;

export const LayerStyleTitle = styled.p`
  padding: 0px;
  padding-left: 10px;
  margin: 0px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
`;

export const LayerStylesWrapper = styled.div`
  padding-left: 25px;
  display: flex;
  flex-direction: column;
`;

export const RadioButton = styled.input`
  appearance: none;
  color: white;
  width: 0.8em;
  height: 0.8em;
  background-color: white;
  margin-top: 5px;
  //border: 0.1em solid currentColor;
  border-radius: 50%;
  :checked {
    background-color: #333333;
    border: 3px solid white;
  }
`;

export const StyleSelectButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const StyleSelectButton = styled.button`
  margin-top: 5px;
  background: #c00000;
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  border: none;
  padding: 3px 25px;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
`;

export const StylesBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const TransparencyPopUp = styled.div`
  margin-right: 30px;
  margin-left: 21.5px;
`;

export const ExportPopUp = styled.div``;
export const ExportButtonsWrapper = styled.div`
  padding-left: 20px;
`;

export const ExportButtonWrapper = styled.div`
  display: flex;
  padding-bottom: 5px;
  align-items: center;
`;

export const ExportButton = styled.button`
  margin-left: 5px;
  background: transparent;
  fill: white;
  border: 0;
  padding: 0;
  display: flex;
  color: white;
  align-items: center;
`;

export const ExportBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const TransparencyBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const InfoBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const InfoDisabledBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const MetadataBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  id: 'MD',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const CloseBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const ExportFormatBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const ExportButtonIcon = styled.img``;

export const ExportTitle = styled.p`
  margin: 0px;
  margin-left: 5px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;

export const CloseIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 22 * percentageSize : 22,
  height: props.fontSizeEnabled ? 22 * percentageSize : 22,
  fill: '#fff'
}))``;

export const SpinnerContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const ColorSelectorWrapper = styled.div``;
